import { createApp } from 'vue'
import App from './App.vue'

// need this due to fonts not being read from the absolute url
if (process.env.NODE_ENV === 'production')
{
  import ('./style-prod.css');
}
else
{
  import ('./style-dev.css');
}

const app_container = import.meta.env.VITE_APP_CONTAINER;

createApp(App).mount(`#${app_container}`);